import React from "react";

const TeachingPhilosophy = () => {
  return (
    <div className="col">
      <p></p>
      <p className="headingFontSize">My Teaching Philosophy</p>
      My teaching philosophy is rooted in the belief that all students can
      learn, given a conducive learning environment and an engaging teaching
      style that caters to their unique needs. I believe that teaching is a
      two‑way process, where both students and teachers learn from one another.
      Below is a glimpse into my modus operandi of teaching.
      <ul>
        <li>
          Teaching After Learning, Learning After teaching:
          <br />I believe that teaching should follow learning and learning
          should follow teaching. Prior to delivering a lecture on a particular
          topic, I introspect about ways to explain the concept in the simplest
          possible terms to someone unfamiliar with the subject matter. Once I
          have arrived at a clear and concise explanation that is satisfactory
          to me, I deliver the same in the lecture while keeping open my thought
          process (you read that right; listening to lectures is a great way to
          delve into the thought process of the person delivering the lecture).
          At regular intervals of time, I solicit feedback on my teaching; this
          allows me to identify areas where my explanations can be refined and
          improved.
        </li>
        <li>
          Teaching as a Tool to Kindle the Spirit of Enquiry:
          <br />
          My exposure to lectures delivered by distinguished researchers has
          reinforced my core belief that effective teaching involves instilling
          in students an intrinsic curiosity and a capacity for enquiry, rather
          than merely providing them with ready-made solutions. Drawing on the
          pedagogical practices of my mentors, I strive to maintain a delicate
          balance between delivering well-crafted material that is easily
          comprehensible, while also offering points of reflection that foster
          students' cognitive development.
        </li>
        <li>
          Undergraduate Teaching Philosophy:
          <br />
          The undergraduate student community in India is renowned for its
          exceptional intellectual capabilities, cultivated through rigorous
          training for entrance exams such as the Joint Entrance Exam (JEE). To
          capitalize on this strength, it is imperative to impart to these
          students the art of breaking down complex problems into smaller,
          manageable tasks, and approach each one of them systematically. To
          achieve this goal, I typically introduce problem sets which comprise a
          number of smaller sub-problems, upon solving all of which the overall
          problem will be solved. I try to present live simulations in class,
          allowing students to observe the source code and witness first-hand
          how simple concepts can be visualised. For instance, in{" "}
          <a href="https://youtu.be/xyjWP0GQD0U">this lecture</a> delivered to
          the undergraduate students at R V College of Engineering, I
          demonstrate using Python simulations how a Gamma distribution can be
          fitted to the data obtained from a certain "odd-one-out" task in
          cognitive neuroscience, and how the goodness of fit can be assessed
          using Kolmogorov--Smirnoff tests. This illustrates how everyday
          phenomena can be quantitatively analyzed using fundamental
          mathematical tools. By presenting such real-world examples in class, I
          attempt to motivate students to explore and apply mathematical
          concepts in their own problem-solving endeavors.
        </li>
        <li>
          Graduate Teaching Philosophy:
          <br />
          While undergraduate education is a crucial foundation for honing a
          student's problem-solving aptitude, typically emphasizing "how" things
          work, graduate studies offers a switches of perspective to understand
          "why" things work the way they work. I believe that it is crucial for
          graduate students to have the ability to assimilate complex ideas from
          a variety of sources and apply them effectively to solve problems. To
          reinforce this essential skill, I typically design questions that
          guide students to think systematically, by breaking bigger problems to
          smaller sub-problems and building on the solution of one sub-problem
          to solve another sub-problem or a different problem.
        </li>
      </ul>
    </div>
  );
};

export default TeachingPhilosophy;
